export const protocolClassNames = {
  objectContainer: "print-100vw max-width-100vw pb-24",
  objectTitleContainer: "rjs-h1-container pb-24 m-0",
  objectTitle: "rjs-h1",
  objectInnerContainer: "section-container flex-row flex-wrap",
}

export const firstProtocolSectionClassNames = {
  fieldContainer: "rjs-full pb-24",
  objectContainer: "rjs-full",
}

export const objectClassNames = {
  primary: {
    fieldContainer: "rjs-full pb-24",
    objectTitleContainer: "rjs-h1-container",
    objectTitle: "rjs-h1",
  },
  secondary: {
    objectTitle: "rjs-h2 mb-8",
    fieldContainer: "rjs-full",
  },
  tertiary: {
    objectTitle: "rjs-h3 mb-8",
    fieldContainer: "rjs-full",
  },
  pactdate: {
    objectTitle: "rjs-h3 mb-8",
  },
  pactdateFull: {
    objectTitle: "rjs-h3 mb-8",
    fieldContainer: "rjs-full",
  },
  contact_root_container: {
    objectTitle: "rjs-h2 mb-8",
    fieldContainer: "rjs-full",
    field: "contact-container",
  },
  contact_nested_container: {
    objectTitle: "rjs-h3 mb-8",
    fieldContainer: "rjs-full",
  },
  dateXl: {
    objectTitle: "rjs-h3 mb-8",
    fieldContainer: "rjs-col-2xl",
  },
}

export const arrayClassNames = {
  primary: {
    arrayTitle: "rjs-h2 mb-8",
    fieldContainer: "rjs-full",
    arrayContainer: "rjs-border-radius mb-16",
    arrayItemsContainer: "rjs-array-items-type-1",
    arrayItemContainer: "rjs-array-item-type-1",
    // actionContainer: "flex justify-end",
    arrayItemTitle: "rjs-h3 mb-8",
    actionContainer: "flex justify-start rjs-full mt-8",
    objectTitle: "mb-4",
  },
  secondary: {
    arrayTitle: "rjs-h3 mb-8",
    fieldContainer: "rjs-full",
    arrayContainer: "rjs-border-radius mb-16",
    arrayItemsContainer: "rjs-array-items-type-1",
    arrayItemContainer: "rjs-array-item-type-1",
    actionContainer: "flex justify-start mt-8",
    arrayItemTitle: "rjs-h3 mb-8",
  },
  tertiary: {
    arrayTitle: "rjs-h3",
    fieldContainer: "rjs-full",
    arrayContainer: "rjs-border-radius mb-16",
    arrayItemsContainer: "rjs-array-items-type-1",
    arrayItemContainer: "rjs-array-item-type-1 flex gap-16",
    actionContainer: "flex justify-start mt-8",
    arrayItemTitle: "rjs-h3 mb-8",
  },
  singleField: {
    arrayTitle: "rjs-h3",
    fieldContainer: "rjs-full",
    arrayContainer: "rjs-border-radius mb-16",
    arrayItemsContainer: "rjs-array-items-type-1",
    arrayItemContainer: "rjs-array-item-type-1",
    actionContainer: "flex justify-start mt-8",
    arrayItemTitle: "rjs-h3",
  },
  nestedArray: {
    arrayTitle: "rjs-h3",
    fieldContainer: "rjs-full",
    arrayContainer: "rjs-border-radius mb-16",
    arrayItemsContainer: "rjs-array-items-type-2",
    arrayItemContainer: "rjs-array-item-type-2",
    actionContainer: "flex justify-start ml-8",
    arrayItemTitle: "rjs-h3",
  },
}

export const dateClassNames = {
  root: {
    objectTitle: "rjs-h3 mb-4",
    // fieldContainer: "rjs-full",
  },
  nested: {},
  rootFull: {
    objectTitle: "rjs-h3 mb-4",
    fieldContainer: "rjs-full",
  },
}
